const kendoAngularDirectivesModuleName = "kendo.directives";
export default kendoAngularDirectivesModuleName;



//////////////////
// WEBPACK FOOTER
// ./src/shims/kendoDirectives.js
// module id = pRL0
// module chunks = 1